import { clsx } from 'clsx';

export interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'animate-pulse rounded-md bg-zinc-200',
        className,
      )}
      aria-hidden="true"
    />
  );
}
